import React, { useState } from 'react';
import { Button, message } from 'antd';
import { QRCodeSVG } from 'qrcode.react';
import IDCard from './components/IDCard';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import TooltipOption from '../../../core/common/tooltipOption';

const StudentAttendance: React.FC = () => {
  const [isInSchool, setIsInSchool] = useState(false);
  const routes = all_routes;

  const checkLocation = async () => {
    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      // Mock school location check - replace with actual coordinates
      const schoolLocation = {
        latitude: 40.7128,
        longitude: -74.0060,
      };

      const distance = calculateDistance(
        position.coords.latitude,
        position.coords.longitude,
        schoolLocation.latitude,
        schoolLocation.longitude
      );

      setIsInSchool(distance <= 0.1);
    } catch (error) {
      message.error('Unable to get location');
    }
  };

  const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371; // Earth's radius in km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * 
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  React.useEffect(() => {
    checkLocation();
    const interval = setInterval(checkLocation, 60000); // Check every minute
    return () => clearInterval(interval);
  }, []);

  const studentData = {
    id: '12345',
    name: 'John Doe',
    class: '10-A',
    photo: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d',
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            {/* <h3 className="page-title mb-1">Student Attendance</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Report</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Teacher Attendance
                </li>
              </ol>
            </nav> */}
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <TooltipOption />
          </div>
        </div>

        <div className="bg-white p-4 rounded-lg shadow border mb-6">
          <QRCodeSVG
            value={JSON.stringify(studentData)}
            size={200}
            level="H"
            includeMargin={true}
          />
          <h3 className="text-lg font-semibold mb-4">Student Details</h3>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Attendance Actions</h3>
          <div className="space-y-4">
            {isInSchool ? (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    console.log('Check in:', new Date().toISOString());
                    message.success('Checked in successfully');
                  }}
                  className="w-full"
                >
                  Check In
                </Button>
                <Button
                  onClick={() => {
                    console.log('Check out:', new Date().toISOString());
                    message.success('Checked out successfully');
                  }}
                  className="w-full"
                >
                  Check Out
                </Button>
              </>
            ) : (
              <p className="text-yellow-600">
                You must be in school to check in or out
              </p>
            )}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
          <h3 className="text-lg font-semibold mb-4">Your ID Card</h3>
          <IDCard type="student" data={studentData as any} variant={'style2'} color={'blue'} />
        </div>
      </div>
    </div>
  );
};

export default StudentAttendance;
